import { createContext, Dispatch, useReducer } from 'react';

import { AppActions, AppState } from '@customTypes/app';
import Reducer from '@store/reducer';

interface StoreProps {
  children: React.ReactNode | React.ReactNode[];
  testDispatch?: React.DispatchWithoutAction;
  initialState?: AppState;
}

export const Context = createContext<[AppState, Dispatch<AppActions>]>([{} as AppState, () => undefined]);

export const initialState: Readonly<AppState> = {
  // User Profile
  userProfile: null,
  hasPartnershipOrdering: false,
  adminClinics: [], // OrganizationRole.ADMIN
  orderingProviderClinics: [], // OrganizationRole.CLINICIAN
  // Patient Management
  formattedProductsList: [],
  patientsMap: {},
  // For Ordering Provider
  clinicalTeam: [],
  // For Admin
  users: [],
  orgDefaultDelegates: [], // OrganizationRole.DELEGATE
};

export const Store: React.FC<StoreProps> = props => {
  const [state, iDispatch] = useReducer(Reducer, props.initialState || initialState);
  const dispatch = props.testDispatch || iDispatch;

  return <Context.Provider value={[state, dispatch]}>{props.children}</Context.Provider>;
};

export default Store;
